document.addEventListener("DOMContentLoaded", function () {
  const closeIcon = document.querySelector(".close-icon");
  closeIcon.addEventListener("click", function () {
    const mainBar = document.querySelector(".discount-bar");
    mainBar.style.display = "none";
  });
});
